import loading from '@assets/images/input-loading.svg'
import styled, { css } from 'styled-components'

const customProps = {
  padding: '10px',
  fontFamily: 'sans-serif',
  fontSize: '16px',
  colorText: '#555',
  borderColor: '#24143E',
}

const placeholderShow = css`
  top: -16px;
  font-size: 12px;
  left: 0;
`

const ContainerField = styled.div`
  position: relative;
  font-family: ${customProps.fontFamily};
  padding-bottom: 15px;

  ${props =>
    props.isLoading &&
    css`
      &::after {
        content: url(${loading});
        color: #555;
        position: absolute;
        top: 0;
        right: calc(${customProps.padding} * 1.5);
        font-size: 26px;
        display: block;
      }
    `}

  ${props =>
    props.fixedLabel &&
    css`
      input + label {
        ${placeholderShow}
      }
    `}

  &input + label,
  input:focus + label,
  input:not(:placeholder-shown) + label {
    ${placeholderShow}
  }
  &.error {
    input {
      border-color: var(--red);
    }
    label {
      color: var(--red);
    }
  }
`

const Label = styled.label`
  position: absolute;
  top: calc(${customProps.padding} * 2);
  left: calc(${customProps.padding} * 2);
  font-size: 16px;
  transition: all 0.3s;
  padding: 0px 5px 0px 5px;
`

const HelpText = styled.div`
  font-size: 12px;
  padding: 1px 5px;
  color: #888;
  border-radius: 5px;
`

const MessageErrorBox = styled.span`
  background: var(--red);
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 0px 5px 2px 5px;
  font-size: 10px;
  display: inline-block;
  font-weight: bold;
  color: #fff;
  border-radius: 0px 5px 0px 5px;
`

const Input = styled.input`
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 40px;
  font-size: ${customProps.fontSize};
  padding: ${customProps.padding};
  border: 1px solid ${customProps.borderColor};
  border-radius: 5px;
  outline: none;

  &:disabled {
    border: 1px solid #bbb;
    color: #aaa;
    background: #eee;
    cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAvlJREFUOBGVlF9I01EUx8+9m9tDLc2oh5RCaRQWIUT00B966g/IfJARBIkpKBGkg8Jmf3Yrcsz+uOwlLU0s6GEIYYX5JkQ9CIEEhhjtQa0ggqbrZW77nb53c2u/MUZe+N17zz3nfO65957fEVSgHVXKWr0cryeDXYJoLwt2CnQwDaObJinGogtzL0OhUDLfHfbm1uTxHpYsBoUgZ0rDNA3W0urcJoTYj7mViWcNotbhXv+7XIIJ2NLhvUhCBIh4CZH0WwQ9fXzfP5fr0NrZWZpcEWeIpA/r5cTcORj0383YZIHNHV0+RKWYadlKtGsg2P0jY1Ro1OBEzPICPicRgG+w139T26WAZ9u9dVKKVzhGVJBwADoRLrPVTSqVKATLWRMtHV2ToBwhprrBYPcb6Xa7LYD16cgShrGHmcew6/HqSGxUP06Oc6Epx4U4DdgfBNOnlJLSUelsgGWVEHxn5EFgPlxmb0hDhet/oCO9t78Bdg2PVT2/FK+XgGkgWaT9kR71MdcKNcg+rH3xQCcksmufToGBe+pXahHdWqHDQRUB4zMJPoSU4y3E4msGlhnXCsXrzoNTqY+sW2ZMS6v9PyhN4I6K3imzSAIqNWgBoW43kXIEDY2W2Vw6lYpB8ahbwfmOOxQfkHs1LR5VnsMxTUNKrRSDNp73bsKGtfg+SkE8rr2ZY40mSp5QDFpio3OIXuDAo0IntqNixxyyfbNMJGuePOxZzGOZRLdSNkdkJZX8qXy1yAtsGDM45c/lxS9OmSpBTB79yxlWy3N4Z/9vE2lVyI+Uk/wJvuvg1q5ZWWcUB4WgfbiHcbIlTg319EQLATNrjZ4rFSXMs9h+PXyuDwW7b2ldFqiFZk/XJVymH9fxm8i4YbHxs4FAIF0LtQFac/vVnSSTTXBsA2gDxssFy1fanAg18SC26cdeu7GWQF2cwpPFtR4ZUQpdbdqWZ1AU2gB7n5bTvSnCjEKhaixEYi7Ix5jEAeRY1aouDMgUInu7baP9NexQtM3tL4+OdUV00mdpAAAAAElFTkSuQmCC),
      default !important;
    user-select: none;
    pointer-events: none;
  }

  &:disabled ~ button {
    opacity: 0.4;
    cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAvlJREFUOBGVlF9I01EUx8+9m9tDLc2oh5RCaRQWIUT00B966g/IfJARBIkpKBGkg8Jmf3Yrcsz+uOwlLU0s6GEIYYX5JkQ9CIEEhhjtQa0ggqbrZW77nb53c2u/MUZe+N17zz3nfO65957fEVSgHVXKWr0cryeDXYJoLwt2CnQwDaObJinGogtzL0OhUDLfHfbm1uTxHpYsBoUgZ0rDNA3W0urcJoTYj7mViWcNotbhXv+7XIIJ2NLhvUhCBIh4CZH0WwQ9fXzfP5fr0NrZWZpcEWeIpA/r5cTcORj0383YZIHNHV0+RKWYadlKtGsg2P0jY1Ro1OBEzPICPicRgG+w139T26WAZ9u9dVKKVzhGVJBwADoRLrPVTSqVKATLWRMtHV2ToBwhprrBYPcb6Xa7LYD16cgShrGHmcew6/HqSGxUP06Oc6Epx4U4DdgfBNOnlJLSUelsgGWVEHxn5EFgPlxmb0hDhet/oCO9t78Bdg2PVT2/FK+XgGkgWaT9kR71MdcKNcg+rH3xQCcksmufToGBe+pXahHdWqHDQRUB4zMJPoSU4y3E4msGlhnXCsXrzoNTqY+sW2ZMS6v9PyhN4I6K3imzSAIqNWgBoW43kXIEDY2W2Vw6lYpB8ahbwfmOOxQfkHs1LR5VnsMxTUNKrRSDNp73bsKGtfg+SkE8rr2ZY40mSp5QDFpio3OIXuDAo0IntqNixxyyfbNMJGuePOxZzGOZRLdSNkdkJZX8qXy1yAtsGDM45c/lxS9OmSpBTB79yxlWy3N4Z/9vE2lVyI+Uk/wJvuvg1q5ZWWcUB4WgfbiHcbIlTg319EQLATNrjZ4rFSXMs9h+PXyuDwW7b2ldFqiFZk/XJVymH9fxm8i4YbHxs4FAIF0LtQFac/vVnSSTTXBsA2gDxssFy1fanAg18SC26cdeu7GWQF2cwpPFtR4ZUQpdbdqWZ1AU2gB7n5bTvSnCjEKhaixEYi7Ix5jEAeRY1aouDMgUInu7baP9NexQtM3tL4+OdUV00mdpAAAAAElFTkSuQmCC),
      default !important;
    user-select: none;
    pointer-events: none;
  }
  &:disabled + label {
    background: transparent;
    cursor: default;
    user-select: none;
    pointer-events: none;
  }
  &.error {
    border: 1px solid var(--red);
  }
`

export { ContainerField, Label, HelpText, Input, MessageErrorBox }
